<script>
import { fandomTranslate } from "src/modules/common_module";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Flickity from "flickity";
import PinContent from "pin-content";

export default {
  components: {
    PinContent
  },
  props: {
    items: Array,
    optItemLayout: String,
    containerContent: Object,
    activeIndex: Number,
  },
  mounted() {
    Vue.nextTick(() => {
      disableBodyScroll(this.$el);
      this.loadCarousel();
    });
  },
  beforeDestroy() {
    clearAllBodyScrollLocks();
  },
  data: function () {
    return {
      carousel: null,
    };
  },
  methods: {
    ft: fandomTranslate,
    loadCarousel() {
      if (Fandom.exists(this.items)) {
        const carousel = new Flickity(this.$refs["items-carousel"], {
          draggable: ">1",
          // adaptiveHeight: true,
          prevNextButtons: false,
          pageDots: (this.items.length > 1),
          cellAlign: "left",
          wrapAround: true,
          initialIndex: this.activeIndex
        });
        Vue.set(this, "carousel", carousel);
        this.carousel.on('change', (index) => {
          this.$emit('next', this.items[index]);
        })
      }
    }
  }
};
</script>

<template>
  <div class="position-fixed h-100vh w-100 d-flex flex-column justify-content-md-center align-items-md-center" modal-carousel-component>
    <div class="close cursor-pointer" @click="$emit('close-modal')">
      <i class="fal fa-times"></i>
    </div>
    <div class="position-relative w-100">
      <div class="custom__prev-button d-flex justify-content-center align-items-center" @click="carousel.previous()">
        <i class="fal fa-chevron-left"></i>
      </div>
      <div class="custom__next-button d-flex justify-content-center align-items-center" @click="carousel.next()">
        <i class="fal fa-chevron-right"></i>
      </div>
      <div class="items-carousel w-100" ref="items-carousel">
        <div class="items-carousel-item w-100 d-flex align-items-md-center justify-content-center" v-for="(item, index) in items">
          <component 
            :is="item.layout || optItemLayout" 
            :content="item"
            :selectedIndex="index"
            :optContainerContent="containerContent"
            v-on:interaction-updated="carousel.next(item)"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[modal-carousel-component] {

  background-color: $white;
  z-index: $zindex-modal;
  top: 0;

  .close {
    position: fixed;
    right: 1rem;
    top: 1rem;
    z-index: 1;
  }

  .items-carousel-item {
    min-height: 100%;
  }

  .custom__prev-button, .custom__next-button {
    top: 50%;
    color: $dark;
    z-index: 1030;
    cursor: pointer;
    position: absolute;
    font-size: 2rem;
    transition: all .25s;
    background-color: $white;
    border-radius: 100%;
    width: 3.5rem;
    height: 3.5rem;

    &:hover {
      opacity: .85;
    }
  }

  .custom__prev-button {
    left: 2.5rem;
  }

  .custom__next-button {
    right: 2.5rem;
  }


  @include media-breakpoint-up(md) {
    .flickity-page-dots {
      display: none;
    }
  }

  @include media-breakpoint-down(sm) {
    overflow-y: scroll;

    .custom__prev-button, .custom__next-button {
      display: none !important;
    }
  }

  @include media-breakpoint-down(xs) {
    overflow-y: scroll;
  }


}
</style>